const getStatus = (percent) => {
  if (percent >= 75) {
    return "success";
  }
  if (percent >= 25) {
    return "warning";
  }
  return "danger";
};

const ProgressBar = ({ available_budget = 0, total_budget = 0 }) => {
  const percent = (available_budget * 100) / total_budget;
  const status = getStatus(percent);

  return (
    <div className="status-progress-bar">
      <div
        className={`status-progress-fill ${status}`}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
};

export default ProgressBar;
